import { ComponentProps, JSXElementConstructor, lazy } from 'react';

/** The dynamic import must stay inline at each call site: Rolldown chunks per unique specifier. */
export const lazyExport = <K extends PropertyKey, M extends Record<K, JSXElementConstructor<ComponentProps<M[K]>>>>(
  loader: () => Promise<M>,
  key: K,
) =>
  lazy(async () => ({
    default: (await loader())[key],
  }));
